import { render, staticRenderFns } from "./MultiStepper.vue?vue&type=template&id=c2159d0a&scoped=true"
import script from "./MultiStepper.vue?vue&type=script&lang=js"
export * from "./MultiStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2159d0a",
  null
  
)

export default component.exports